<template>
  <o-modal v-if="isModalVisible" @showModal="showModal" @close="closeModal">
    <template v-slot:header>
      {{ item.title }}
    </template>

    <template v-slot:body>
      <div v-if="page.isLoading" class="d-flex justify-content-center spinner-border text-primary spinner-position"></div>
      <div class="spinner" v-if="page.isLoading"></div>

      <o-form @submit.prevent="saveCampaign" autocomplete="off">
        <div v-if="validation.length">
          <div class="alert alert-danger">
            <p>
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="(item, index) in validation" :key="index">{{ item }}</li>
              </ul>
            </p>
          </div>
        </div>

        <o-form-group title="Campaign Name" name="name" class="text-start mb-2">
          <span class="text-danger"> *</span>
          <o-input-text
            name="name"
            v-model="item.name"
            :required="true"
            :autocomplete="'off'"
            type="text"
          />
        </o-form-group>

        <div class="d-flex d-inline-block">
          <div class="me-2">
            <o-button @click="saveCampaign" :variant="'primary'" :white="'white'" type="submit">Save</o-button>
          </div>
        </div>
      </o-form>
    </template>
  </o-modal>
</template>

<script>
import { OModal, OForm, OFormGroup, OInputText, OButton } from "@/components/OmnihControl";

export default {
  name: "CampaignForm",
  components: {
    OModal,
    OForm,
    OFormGroup,
    OInputText,
    OButton
  },
  props: {
    editedItem: Object,
    validationdetail: Array
  },
  data() {
    return {
      item: {
        name: "",
        title: "Create Campaign"
      },
      validation: [],
      page: {
        isLoading: false
      },
      isModalVisible: true
    };
  },
  mounted() {
    if (this.editedItem && Object.keys(this.editedItem).length > 0) {
      this.item = { ...this.editedItem }; // Populate fields for editing
      this.item.title = "Edit Campaign";
    }
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.$emit("parentCloseModal");
    },
    saveCampaign() {
      this.validation = [];

      if (!this.item.name) {
        this.validation.push("Name is required.");
      }

      if (this.validation.length === 0) {
        // Emit the data to the parent for saving or updating
        const campaignData = { ...this.item };

        if (campaignData.id) {
          // Update campaign if 'id' exists
          this.$emit("parentSaveItem", campaignData);
        } else {
          // Create new campaign if 'id' doesn't exist
          this.$emit("parentSaveItem", campaignData);
        }

        this.closeModal(); // Close modal after save
      }
    }
  }
};
</script>
